import { useQuery } from '@shared/modules/use-query/hooks'
import { Warehouse } from '../types'
import { useCallback, useMemo } from 'react'
import { WarehousesService } from '../services'

export const useWarehouseList = () => {
  return useQuery<Warehouse[]>(
    useCallback(async () => {
      const result = await WarehousesService.getSelect()

      if (result.status === 200) {
        return result.data
      } else {
        return []
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
